export interface ISponsorPromotionTileProps {
    imgSrc: string;
    imgAlt: string;
}

export const SponsorPromotionTile = ({
    imgSrc,
    imgAlt
}: ISponsorPromotionTileProps) => {

    return (
        <div className="partner-tile__promo">

            <img
                src={imgSrc}
                alt={imgAlt}
                className="partner-tile__promo-img"
                loading="lazy"
            />

            {/* później możemy dodać opis lub przycisk */}

        </div>
    );
};
